import {NgModule} from '@angular/core';
import {ToggleSwitchComponent } from './toggle-switch.component';

@NgModule({
   exports: [ToggleSwitchComponent],
   declarations: [ToggleSwitchComponent ]
})

export class ToggleSwitchModule {
}